
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getUsers",
      resolverType: "query",
      routePath: "/getUsers",
      httpMethod: "POST",
    });
  